// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--KzCqU";
export var footerContainer = "footer-module--footerContainer--O--EO";
export var brand = "footer-module--brand--1fXd5";
export var text = "footer-module--text--n3yRa";